
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from "@/components/ui/toaster";
import Auth from '@/pages/Auth';
import Builder from '@/pages/Builder';
import Templates from '@/pages/Templates';
import Offers from '@/pages/Offers';
import Index from '@/pages/Index';
import Chats from '@/pages/Chats';
import Settings from '@/pages/Settings';
import Pricing from '@/pages/Pricing';
import Account from '@/pages/Account';
import BetaAdmin from '@/pages/BetaAdmin';
import Documentation from '@/pages/Documentation';
import PublicOfferViewPage from '@/pages/PublicOfferView';
import PublicComparisonViewPage from '@/pages/PublicComparisonView';
import { AuthProvider } from '@/context/AuthContext';
import { CompanySettingsProvider } from '@/context/CompanySettingsContext';
import { ThemeProvider } from '@/context/ThemeContext';
import Layout from '@/components/Layout';
import RequireAuth from '@/components/RequireAuth';
import { AnimatedSidebarProvider } from '@/components/ui/animated-sidebar';
import './styles/rich-message.css';

const App: React.FC = () => {
  return (
    <ThemeProvider defaultTheme="dark">
      <AuthProvider>
        <CompanySettingsProvider>
          <AnimatedSidebarProvider>
            <div className="h-full w-full overflow-hidden">
              <Routes>
                <Route path="/auth" element={<Auth />} />
                {/* Public routes that don't require authentication */}
                <Route path="/" element={<Index />} />
                <Route path="/offer/:id" element={<PublicOfferViewPage />} />
                <Route path="/comparison/:id" element={<PublicComparisonViewPage />} />
                <Route path="/offer" element={<PublicOfferViewPage />} />
                <Route path="/comparison" element={<PublicComparisonViewPage />} />
                
                {/* Protected routes that require authentication */}
                <Route element={<RequireAuth><Layout /></RequireAuth>}>
                  <Route path="/builder" element={<Builder />} />
                  <Route path="/builder/:chatId" element={<Builder />} />
                  <Route path="/templates" element={<Templates />} />
                  <Route path="/offers" element={<Offers />} />
                  <Route path="/chats" element={<Chats />} />
                  <Route path="/chats/:chatId" element={<Builder />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/documentation" element={<Documentation />} />
                </Route>
                
                {/* Admin route */}
                <Route path="/beta-admin" element={
                  <RequireAuth adminOnly={true}>
                    <Layout>
                      <BetaAdmin />
                    </Layout>
                  </RequireAuth>
                } />
                
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Toaster />
            </div>
          </AnimatedSidebarProvider>
        </CompanySettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
